import styled, { css, keyframes } from 'styled-components';
const stubLeft = '/wp-content/themes/wbstl/images/hero-cta-stub-left.svg';
const stubRight = '/wp-content/themes/wbstl/images/hero-cta-stub-right.svg';
const stubLeftHover = '/wp-content/themes/wbstl/images/hero-cta-stub-left-hover.svg';
const stubRightHover = '/wp-content/themes/wbstl/images/hero-cta-stub-right-hover.svg';
const capLeft = '/wp-content/themes/wbstl/images/badges-images-cap-left.svg';
const capRight = '/wp-content/themes/wbstl/images/badges-images-cap-right.svg';
const h2Left = '/wp-content/themes/wbstl/images/flourish-2-left.svg';
const h2Right = '/wp-content/themes/wbstl/images/flourish-images-right.svg';
const checkmark = '/wp-content/themes/wbstl/images/checkmark.svg';
const close = '/wp-content/themes/wbstl/images/icon_close.svg';
const printer = '/wp-content/themes/wbstl/images/icon_printer.svg';

export const Container = styled.div`
  margin: 0 auto;
  max-width: 1200px;
`;
const h2Flourish = css`
  background-position: 0 -4px;
  height: 24px;
  width: 70px;
`;
export const Header = styled.div`
  background: #fff;
  padding: 0 0 5px 0;
  position: relative;
  text-align: center;

  h2 {
    font-size: 28px;
    line-height: 40px;
    display: inline-block;
    margin: 15px auto 0;
    position: relative;
    max-width: calc(100% - 120px);

    &::before {
      ${h2Flourish}
      background-image: url(${h2Left});
      top: 37%;
    }
    &::after {
      ${h2Flourish}
      background-image: url(${h2Right});
      top: 37%;
    }
  }
`;
const CapStyle = css`
  background-repeat: no-repeat;
  background-size: contain;
  content: "";
  display: block;
  height: 48px;
  position: absolute;
  top: 0;
  width: 70px;
`;
export const Flourish = styled.div`
  @media (min-width: 1024px) {
    &::before {
      ${CapStyle}
      background-image: url(${capLeft});
      left: calc( (100% - 400px) / 2);
    }
    &::after {
      ${CapStyle}
      background-image: url(${capRight});
      right: calc( (100% - 400px) / 2);
    }
  }
`;
export const HeroBg = styled.div`
  background-image: linear-gradient(rgba(0,0,0,.3), rgba(0,0,0,.3)), url(${props => props.heroBg});
  align-items: center;
  background-position: 50% 50%;
  background-size: 1919px;
  color: #fff;
  display: flex;
  flex-direction: column;
  height: 280px;
  justify-content: center;
  padding: 30px 25px;
  text-align: center;
  width: 100%;
  transition: all .25s ease-in;
  background-size: cover;

  @media (min-width: 1024px) {
    height: 450px;

    &.short {
      height: 330px;
    }
  }
  svg {
    fill: #fff;
    width: 140px;
  }
  h1 {
    margin: -20px auto 0 auto;
    font-family: 'Lora', serif;
    font-weight: normal;
    text-transform: none;
    max-width: 1000px;
    font-size: 36px;

    @media (min-width: 768px) {
      font-size: calc(18px + 40 * ((100vw - 320px) / 1120));
      width: 64%;
    }
  }
  &.shrink {
    height: 250px;
    justify-content: flex-end;

    h1 {
      font-size: 36px;
    }
  }
  &.expand {
    height: 300px;
  }
`;
export const StepsNav = styled.div`
  background: #002A4E;
  width: 100%;
  display: flex;
  justify-content: center;

  @media (min-width: 576px) {
    border-radius: 8px 8px 0 0;
  }
`;
export const TabsRow = styled.div`
  background: #F2F2F2;
  margin-bottom: 30px;
`;
export const TabsWrapper = styled.div`
  margin: ${props => props.isDropdown ? '20px' : '0 20px'};
  width: ${props => props.linear ? 'auto': 'calc(100% - 40px)'};
  display: flex;
  flex-direction: column;
  height: ${props => props.isDropdown ? '50px' : '40px'};
  overflow: hidden;
  align-items: flex-end;
  justify-content: flex-start;
  align-content: center;
  z-index: 5;
  position: relative;
  border: ${props => props.isDropdown ? '1px solid #000' : 'none'};

  &.open {
    overflow: visible;
  }
  @media (min-width: 600px) {
    flex-direction: row;
    justify-content: space-around;
    height: 50px;
    align-items: center;
  }
  @media (min-width: 1140px) {
    max-width: 1100px;
    margin: 0 auto;
  }
`;
export const Tab = styled.div`
  vertical-align: middle;
  text-align: center;
  line-height: 1;
  width: ${props => props.linear ? '150px' : 'calc(100% - 2px)'};
  font-size: 21px;
  font-family: Montserrat,sans-serif;
  font-weight: 700;
  color: #535353;
  box-sizing: border-box;
  display: block;
  position: relative;
  padding-bottom: 3px;
  margin: 0 1px;
  transform: translateY(${props => props.isDropdown ? props.transformBy : 0}%);

  &:hover {
    color: #000;
  }
  span {
    border-bottom: ${props => props.linear ? '2px solid transparent' : 'none'};
    line-height: ${props => props.isDropdown ? '40px' : '1em'};
    display: inline-block;
    padding: 5px;
    white-space: nowrap;
  }
  &.active {
    display: none;
    .fa-chevron-down {
      display: inline-block;
    }
  }
  &.clickable {
    cursor: pointer;
  }
  &.step {
    color: #fff;
    font-weight: normal;
    width: auto;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    cursor: default;
    border: none;
    white-space: nowrap;

    @media (min-width: 576px) {
      font-size: 16px;
    }
    @media (min-width: 768px) {
      font-size: 18px;
      height: 40px;
      line-height: 40px;
    }

    &.active {
      display: inline-block;
      font-weight: 700;
      cursor: pointer;
      span {
        text-decoration: underline;
        border: none;
      }
    }
    &.current {
      color: #F6BD49;
      font-weight: 700;
      span {
        text-decoration: underline;
        border: none;
      }
    }

  }
  .fa-chevron-down {
    display: ${props => props.isDropdown ? 'inline-block' : 'none'};
    margin-left: 10px;
  }
  .fa-chevron-right {
    margin: 0 2px;
    font-size: 12px;

    @media (min-width: 576px) {
      color: #fff;
    }
    @media (min-width: 768px) {
      margin: 0 1em;
      font-size: 15px;
    }
  }

  @media (min-width: 600px) {
    position: relative;
    border: none;

    .fa-chevron-down, &.active .fa-chevron-down {
      display: none;
    }
  }
`;
export const TabContent = styled.div`
  margin: 0;
  background: #fff;
  border-radius: 8px;
  transition: background 1s ease-in;

  @media (min-width: 576px) {
    margin: 0 20px 30px 20px;
    box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.25);
  }
  @media (min-width: 1140px) {
    max-width: 1100px;
    margin: 0 auto 30px auto;
  }
  &.loaded {
    background: #F2F2F2;
  }
`;
export const Sides = styled.div`
  display: flex;
  align-items: stretch;
  transition: all 1s ease-in-out;
  flex-wrap: wrap;
  padding: 10px 20px;

  @media (min-width: 576px) {
    padding: 30px;
  }
  @media (min-width: 768px) {
    padding: 30px 20px;
  }
  @media (min-width: 1024px) {
    padding: 30px;
  }
  &.nopad {
    padding: 0;
  }
`;
const SplitStyles = css`
  width: 100%;

  @media (min-width: 768px) {
    width: 50%;
  }
`;
export const Sidebar = styled.div`
  width: 100%;
  margin-top: 20px;

  @media (min-width: 768px) {
    width: 45%;
    margin-top: 0;

    .inner {
      text-align: left;
      margin-left: 0.5rem;
    }
  }
  @media (min-width: 992px) {
    width: 35%;
    .inner {
      margin-left: 20px;
    }
  }
  &.mobileReverse {
    @media (max-width: 767px) {
      order: 1;
    }
  }
`;
export const Main = styled.div`
  width: 100%;

  @media (min-width: 768px) {
    width: 55%;

    .inner {
      text-align: left;
      position: relative;
    }
  }
  @media (min-width: 992px) {
    width: 65%;
  }
  &.mobileReverse {
    @media (max-width: 767px) {
      order: 2;
    }
  }
`;
export const Left = styled.div`
  ${SplitStyles}

  @media (min-width: 768px) {
    .inner {
      text-align: left;
      margin-right: 1.5rem;
      position: relative;
    }
  }
`;
export const Right = styled.div`
  ${SplitStyles}
  margin-top: 2em;

  @media (min-width: 768px) {
    margin-top: 0;

    .inner {
      text-align: left;
      margin-left: 1.5rem;
    }
  }
`;
export const EmptyMessage = styled.p`
  font-style: italic;
  font-family: 'Montserrat',sans-serif;
  text-align: left;
  margin: 20px 0 10px 0;
  font-size: 16px;
`;
export const VDivider = styled.div`
  width: 4%;
  hr {
    height: 100%;
    margin: auto;
    width: 1px;
    background: #ccc;
  }
`;
export const BookingIntro = styled.div`
  font-family: 'Lora', serif;
  font-weight: normal;
  font-size: 21px;
  max-width: 1000px;
  margin: 2em 10px;
  text-align: center;
  line-height: 1.2em;

  @media (min-width: 1024px) {
    font-size: 24px;
    margin: 2em auto;
  }
`;
export const BookingAvailability = styled.div`
  background: #FFFFFF;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  max-width: 1024px;
  padding: 24px;
  margin: 0 auto 3em auto;
  font-family: "Montserrat",sans-serif;
  font-weight: bold;

  @media (max-width: 1080px) {
    margin: 0 20px 3em 20px;
  }
  .inner {
    padding: 0 20px;
    @media (min-width: 768px) {
      padding: 0 0px 0 60px;
    }
    .row {
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      padding: 10px 0;
      align-items: center;
    }
    .leftSide {
      width: 100%;
      @media (min-width: 768px) {
        width: 75%;
      }
    }
    .rightSide {
      width: 100%;
      text-align: center;
      margin: 20px 0;

      @media (min-width: 768px) {
        width: 25%;
        margin: 0;
      }
    }
  }
  hr {
    height: 1.5px;
    background-color: #F6BD49;
    width: 120px;
    margin: 0 auto;
    border: none;
    @media (min-width: 768px) {
      transform: translateX(-30px);
    }
  }
`;
export const TicketTypes = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  flex-wrap: wrap;

  @media (min-width: 992px) {
    flex-wrap: nowrap;
  }
`;
export const TicketType = styled.div`
  display: flex;
  flex-direction: column;
  width: 98%;
  background: #fff;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 2px 20px rgba(0,0,0,.15);
  position: relative;
  margin-bottom: 2.5rem;

  @media (min-width: 600px) {
    width: 48%;
    border-radius: 4px;
  }
  @media (min-width: 992px) {
    width: 31%;
  }
  .image {
    height: 200px;
  }
  &:hover .image .bg {
    transform: scale(1.1);
  }
`;
export const TicketMiddle = styled.div`
  width: 100%;
  
`;
export const PriceTag = styled.div`
  position: absolute;
  color: #fff;
  font-family: 'Montserrat',sans-serif;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: .92px;
  text-align: center;
  height: 60px;
  width: 100%;
  box-shadow: 0px 14px 15px -15px rgba(0,0,0,.5);
  line-height: .8em;
  padding: 0px 20px;
  z-index: 5;
  background: rgba(83, 83, 83, .75);

  &.studio-tour, &.gift-tickets {
    background: rgba(12, 42, 75, .75);
  }
  &.behind-the-seams {
    background: rgba(33, 87, 133, .75);
  }
  &.deluxe-tour {
    background: rgba(38, 21, 65, .75);
  }
  span {
    font-size: 10px;
    display: block;
    text-align: center;
  }
`;
export const TicketTitle = styled.div`
  color: #fff;
  background: #535353;
  line-height: 1.2em;
  padding: .5em 0;
  width: 100%;
  font-weight: normal;
  font-size: 1.5rem;
  text-align: center;
  cursor: pointer;
  border-radius: 4px 4px 0 0;

  &.studio-tour, &.gift-tickets {
    background: #0c2a4b;
  }
  &.behind-the-seams {
    background: #215785;
  }
  &.deluxe-tour {
    background: #261541;
  }
`;
export const TicketImage = styled.div`
  overflow: hidden;
  height: 200px;
  width: 100%;
  cursor: pointer;
`;
export const BG = styled.div`
  height: 100%;
  width: 100%;
  background-image: url(${props => props.bg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  transition: all .25s ease-out;
  z-index: 1;
`;
export const TicketDesc = styled.div`
  width: 100%;
  font-family: "Montserrat",sans-serif;
  padding: 5px 20px;
  text-align: center;
  font-size: 12px;
  line-height: 1.5em;
  font-weight: bold;
  background: #F2F2F2;
`;
export const TicketFeatures = styled.div`
  font-family: "Montserrat",sans-serif;
  padding: 15px 20px;
  text-align: left;
  flex: 2;
  font-size: 1rem;
  line-height: 1.5em;

  ul {
    margin: 0;
  }
  li {
    list-style: none;
    position: relative;
    font-size: 12px;
    font-weight: bold;

    &::before {
      top: 5px;
      left: -30px;
      content: '';
      background-image: url(${checkmark});
      width: 20px;
      height: 100%;
      position: absolute;
      background-repeat: no-repeat;
    }
  }
`;
export const MoreLink = styled.div`
  font-family: "Montserrat",sans-serif;
  padding: 10px 20px;
  text-align: left;
  font-size: 1rem;
  font-weight: bold;
  line-height: 1.5em;
  color: #005789;
  cursor: pointer;

  &:hover {
    color: #002A4E;
  }
`;
export const Link = styled.div`
  text-decoration: underline;
  font-weight: bold;
  color: #005789;
  cursor: pointer;
  display: inline;

  &:hover {
    color: #002A4E;
  }
`;
export const PrintButton = styled.button`
  background: #F2F2F2;
  color: #000;
  border: 1px solid #A9A9A9;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 16px;
  font-family: "Montserrat",sans-serif;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;

  &:before {
    content: '';
    background-image: url(${printer});
    width: 25px;
    height: 25px;
    background-size: cover;
    margin-right: 10px;
    display: block;
    float: left;
  }
`;
export const BookButton = styled.button`
  background-color: #f6bd49;
  color: #000;
  margin: 0;
  width: 75%;
  border: 0px;
  font-weight: 700;
  font-size: 18px;
  letter-spacing: 1px;
  line-height: 24px;
  padding: 10px 0px 12px 0px;
  text-decoration: none;
  transition: background-color .2s ease-out;
  position: relative;
  cursor: pointer;

  &::before, &::after {
    content: "";
    position: absolute;
    display: block;
    top: 0;
    bottom: 0;
    width: 14px;
    background-size: auto 100%;
    background-position: 50%;
    background-repeat: no-repeat;
  }
  &::before {
    left: -16px;
    background-image: url(${stubLeft});
  }
  &::after {
    right: -16px;
    background-image: url(${stubRight});
  }
  &:hover {
    background: #DFAA3E;
  }
  &:hover::before {
    background-image: url(${stubLeftHover});
  }
  &:hover::after {
    background-image: url(${stubRightHover});
  }
`;
export const QuickBookSelection = styled.span`
  cursor: pointer;
  color: #005789;

  &:hover {
    color: #0c2a4b;
  }
  i {
    font-size: .85em;
    font-style: normal;
  }
`;
const fadeUp = keyframes`
  from {
    opacity: 0;
    top: 50%;
  }
  to {
    opacity: 1;
    top: 0;
  }
`;
export const Modal = styled.div`
  background: rgba(0, 0, 0, .5);
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 95;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  &.loader {
    background: rgba(255, 255, 255, .7);
  }
`;
export const ModalContent = styled.div`
  background: ${props => props.loaded ? '#f2f2f2' : '#fff'};
  width: ${props => props.size == 'small' ? '550px' : '60%'};
  max-width: 100%;
  margin: 0 auto;
  box-shadow: 0 10px 20px rgba(0,0,0,.5);
  position: relative;
  z-index: 100;
  padding: 20px;
  animation: ${fadeUp} 250ms ease;
  border: 2px solid #F6BD49;
  font-family: "Montserrat",sans-serif;
  border-radius: 4px;

  &.image {
    width: auto;
    line-height: 1;
    padding: 0;
  }
  @media (min-width: 600px) {
    max-width: 80%;
  }
  @media (min-width: 768px) {
    max-width: 60%;
    padding: 20px 30px;
  }
  @media (min-width: 1024px) {

  }
  @media (min-width: 1200px) {

  }
`;
export const MessageWrapper = styled.div`
  background: rgba(255, 255, 255, .98);
  border-radius: 4px;
  margin: 0 20px 0 0;
  width: auto;
  display: inline-block;
  padding: 15px 25px 15px 15px;
  z-index: 10;
  border: 2px solid #F6BD49;
  text-align: center;
  left: 0;
  line-height: 1.2em;
  font-size: 16px;
`;
export const BookingContent = styled.div`
  width: 100%;
`;
export const Row = styled.div`
  display: flex;
  align-items: center;
  transition: all 1s ease-in-out;
  margin-bottom: 10px;
  width: 100%;
  justify-content: space-between;

  @media print {
    justify-content: flex-start;
  }
  &.with-label {
    justify-content: flex-start;
  }
  &.ticketClickable {
    cursor: pointer;

    > div:first-child {
      width: 50%;
      justify-content: flex-start;
    }
  }
  &.ticketItem {
    display: flex;
    align-items: flex-start;
    &.with-image {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
    }
    @media (min-width: 520px) {
      align-items: center;
      &.with-image {
        display: block;
      }
    }
    @media (min-width: 768px) {
      &.with-image {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
      }
    }
    @media (min-width: 992px) {
      flex-wrap: nowrap;
      align-items: center;

      &.with-image {
        align-items: center;
      }
    }
    .price {
      @media (max-width: 991px) {
        text-align: left;
      }
    }
  }
  &.pad {
    margin-bottom: 15px;

    &:last-child {
      margin-bottom: 0;
    }
  }
  &.padtop {
    margin-top: 15px;
  }
  &.nobottom {
    margin-bottom: 0;
  }
  &.spaceBetween {
    justify-content: space-between;
  }
  &.center {
    justify-content: center;
  }
  &.gutter {
    padding: 0 15px;
  }
  .label {
    width: 150px;
  }
  hr {
    margin: 15px 0;
  }
`;
export const Col = styled.div`
  margin: 0 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  @media print {
    width: 65%;
    text-align: left;
    justify-content: flex-start;
  }
  @media (min-width: 520px) {
    width: 25%;
  }
  @media (min-width: 768px) {
    width: 28%;
    flex-wrap: nowrap;
  }
  @media (min-width: 992px) {
    width: 28%;
    flex-wrap: nowrap;
  }
  &.image {
    width: 100%;
    border: 3px solid #f6bd49;
    border-radius: 4px;
    margin: 15px 0;

    @media (min-width: 520px) {
      width: 35%;
      margin: 5px 20px 0 0;
      float: left;
    }
    @media (min-width: 768px) {
      align-self: flex-start;
      margin: 5px 10px 0 0;
      width: 25%;
    }
    @media (min-width: 992px) {
      width: 30%;
    }
    img {
      width: 100%;
    }
  }
  &.name {
    margin-left: 0;
    text-align: left;
    justify-content: flex-start;
    align-self: center;
    align-items: flex-start;
    width: calc(70% - 10px);

    @media (min-width: 520px) {
      width: calc(60% - 10px);
      .price {
        display: none;
      }
    }
    @media (min-width: 768px) {
      width: 100%;

      &.with-image {
        width: calc(75% - 26px);
      }
    }
    @media (min-width: 992px) {
      width: 60%;

      &.with-image {
        width: calc(38% - 26px);
      }
    }
    @media (min-width: 1200px) {
      width: 70%;
    }
    @media print {
      width: 35% !important;
    }

  }
  &.price {
    width: 25%;
    display: none;

    @media (min-width: 520px) {
      width: calc(15% - 20px);
      display: block;
    }
    @media (min-width: 768px) {
      width: 50%;
      margin-left: 0;
    }
    @media (min-width: 992px) {
      width: 10%;
      margin-left: 10px;
    }
    @media (min-width: 1200px) {
      width: 12%;
    }
    &.with-image {
      @media (min-width: 520px) {
        margin-left: 0;
        width: calc(25% - 10px);
        display: inline;

        .price {
          display: inline-block;
        }
      }
      @media (min-width: 768px) {
        margin-left: calc(25% + 16px);
        width: calc(25% - 10px);
        display: block;
      }
      @media (min-width: 992px) {
        margin-left: 0;
        width: calc(15% - 10px);
        text-align: right;
      }
    }
  }
  &.counter {
    width: calc(30% - 10px);
    margin-right: 0;
    padding-top: 10px;
    white-space: nowrap;
    display: flex;
    align-items: center;

    @media (min-width: 520px) {
      width: calc(25% - 20px);
      margin-right: 10px;
      padding-top: 0;

      &.with-image {
        float: right;
        margin-top: 10px;
      }
    }
    @media (min-width: 768px) {
      width: 25%;
      &.with-image {
        float: none;
        margin-top: 0;
      }
    }
    @media (min-width: 992px) {
      width: calc(17% - 20px);

      &.with-image {
        width: calc(17% - 20px);
      }
    }
    @media (min-width: 1200px) {
      width: 18%;
    }
  }
  &.stacked {
    flex-direction: column;
    align-items: flex-start;
  }
  &.left-align {
    justify-content: flex-start;
  }
  &.right-align {
    align-items: flex-end;
  }
  &.middle {
    align-items: center;
    justify-content: center;
  }
`;
export const Col2 = styled.div`

  @media print {
    width: 65%;
    text-align: left;
    justify-content: flex-start;
  }
  &:first-child {
    display: flex;
    flex-direction: column;
  }
  &.image {
    @media (min-width: 520px) {
      justify-content: flex-start;
      align-self: flex-start;
      padding: 10px 0 0 0;
    }
    img {
      width: 100%;
    }
  }
  &.text-right {
    text-align: right;
  }
  &.right-align {
    align-items: flex-end;

    h5 {
      text-align: right;
    }
  }
  &.counter {
    display: flex;
    align-items: center;
  }
`;
export const HalfCol = styled.div`
  margin: 0 10px;
  width: 50%;
  display: flex;
  justify-content: space-around;
  align-items: center;

  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
  &.left-align {
    justify-content: flex-start;
    margin: 0 10px;
  }
  &.right-align {
    justify-content: flex-end;
    margin: 0 10px;
  }
`;
export const Label = styled.label`
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  letter-spacing: 1.6px;
  text-transform: uppercase;
  line-height: 1em;
`;
export const Value = styled.div`
  font-family: "Montserrat", sans-serif;
  font-size: 20px;
`;
export const LabelCol = styled.div`
  margin: 0 10px 0 0;
  flex: 1;
  text-align: left;
`;
export const ValueCol = styled.div`
  margin: 0 10px;
  flex: 2;
  text-align: right;
  line-height: 1.2em;
`;
export const ParkingSection = styled.div`
  position: relative;
`;
export const Block = styled.div`
  background: #fff;
  border-radius: 4px;
  hr {
    border-color: #495160;
    margin: 25px 0 15px 0;
  }
  .body {
    padding: 16px;
  }
`;
export const Block2 = styled.div`
  padding: 16px;
  margin-top: 1em;
  a {
    color: #005789;

    &:hover {
      color: #0c2a4b;
    }
  }
`;
export const Faq = styled.div`
  margin-bottom: 20px;
  `;
export const Question = styled.div`
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  color: #005789;
  line-height: 1.4em;
  margin-bottom: 5px;
  cursor: pointer;
  position: relative;
  padding-right: 20px;

  &:hover {
    color: #0c2a4b;
  }
  .fa {
    color: #535353;
    margin-left: 5px;
    position: absolute;
    right: 5px;
    top: 3px;
  }
`;
export const Answer = styled.div`
  font-size: 14px;
  font-family: "Montserrat", sans-serif;
  line-height: 1.4em;
`;
export const Space = styled.div`
  min-height: ${props => props.minHeight}px;
  text-align: center;
  display: flex;
  transition: all .5s ease-in;
`;
export const Section = styled.div`
  margin-top: 1rem;
  padding-top: 1rem;
  position: relative;

  > div {
    width: 100%;
  }
  &.padsides {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  &.padbottom {
    margin-bottom: 1rem;
    padding-bottom: 1rem;
  }
  &.nopad {
    margin-top: 0;
    padding-top: 0;
  }
  &.center {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &.white {
    padding: 20px 0 0 20px;
    background: #fff;
  }
  @media (min-width: 600px) {
    border-bottom: none;
  }
  hr {
    margin: 15px 0;
  }
`;
export const Name = styled.h5`
  line-height: 1em;
  text-transform: none;
  position: relative;
  margin: .5em 0;
  text-align: left;
  font-size: 20px;

  &.singleLine {
    line-height: 32px;
  }
`;
const ellipsis = keyframes`
  from {
    width: 0px;
  }
  to {
    width: 1.25em;
  }
`;

export const Name2 = styled.span`
  position: relative;
  font-weight: normal;
  font-family: "Montserrat",sans-serif;
  font-size: 16px;
  line-height: 1.2em;
  display: block;

  &.bold {
    font-weight: bold;
  }
  &.gray {
    color: #555;
  }
  &.active {
    color: #005789;
  }
  .fa {
    display: inline-block;
    margin: 0 5px 0 0;
    font-size: 12px;
  }
  &.qty span {
    width: 18px;
    text-align: right;
    display: inline-block;
  }
  &.loading::after {
    overflow: hidden;
    display: inline-block;
    vertical-align: bottom;
    -webkit-animation: ${ellipsis} steps(4,end) 900ms infinite;
    animation: ${ellipsis} steps(4,end) 900ms infinite;
    content: "\2026";
  }
`;
const FlourishStyle = css`
  background-repeat: no-repeat;
  background-size: contain;
  content: "";
  display: block;
  height: 18px;
  position: absolute;
  top: -2px;
  width: 50px;
`;
export const BasketTitle = styled.h3`
  font-size: 18px;
  line-height: 40px;
  padding: 10px 16px;
  text-transform: none;
  margin-top: 0;
  border-bottom: 2px solid #F6BD49;
  width: 100%;
  letter-spacing: 0;
`;
export const BasketTitle2 = styled.h3`
  font-size: 18px;
  line-height: 1.2;
  padding: 0 20px 20px 20px;
  margin-bottom: 10px;
  text-transform: none;
  letter-spacing: 0;
  border-bottom: 2px solid #F6BD49;

  &.padtop {
    padding-top: 10px;
  }
`;
export const Quantity = styled.div`
  background: #005789;
  width: 24px;
  height: 24px;
  text-align: center;
  line-height: 24px;
  border-radius: 4px;
  color: #fff;
  font-family: "Montserrat",sans-serif;
  font-size: 18px;
  font-weight: bold;
  display: inline-block;

  @media print {
    color: #000;
  }
`;
export const Title = styled.h3`
  font-size: 18px;
  line-height: 1.2;
  margin-top: 15px;
  cursor: ${props => props.clickable ? 'pointer' : 'default'};
  &:hover {
    color: ${props => props.clickable ? '#999' : '#000'};
  }
`;
export const Title2 = styled.h3`
  font-size: 18px;
  line-height: 1.2;
  margin-top: 15px;
  text-transform: none;
  letter-spacing: 0;

  @media print {
    margin: 0;
  }
`;
export const Title3 = styled.h3`
  font-size: 20px;
  text-transform: none;
  color: #535353;
  margin-top: 20px;
  margin-bottom: 15px;
  letter-spacing: 0;
`;
export const Subtitle = styled.h6`
  line-height: 1em;
  position: relative;
  margin-bottom: 1em;
  display: inline-block;

  &.center {
    transform: translateX(-50%);
    left: 50%;
  }
  &::before {
    ${FlourishStyle}
    left: -50px;
    background-image: url(/wp-content/themes/wbstl/images/flourish-3-left.svg);
  }
  &::after {
    ${FlourishStyle}
    right: -50px;
    background-image: url(/wp-content/themes/wbstl/images/flourish-3-right.svg);
  }
  &.blank::before, &.blank::after {
    background: none;
  }
  &.white {
    margin-right: 20px;
  }
`;

export const PopupMessage = styled.div`
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  position: ${props => props.inline ? 'relative' : 'absolute'};
  width: ${props => props.small ? '180px' : props.inline ? '100%' : '50%'}
  padding: ${props => props.withButton ? '25px 25px 10px 25px' : '25px'};
  z-index: 10;
  border: 2px solid #f6bd49;
  text-align: left;
  max-width: 500px;
  left: 0;
  line-height: 1.2em;
  font-size: .9em;
  font-family: "Montserrat",sans-serif;
  padding: 15px;
  margin: 0 30px;
`;

export const CloseBtn = styled.div`
  position: absolute;
  right: 15px;
  top: 5px;
  cursor: pointer;
  font-size: 21px;
  z-index: 10;

  &.small {
    right: 10px;
    font-size: 14px;
  }
  &.outside {
    right: -20px;
    top: -20px;
    }
`;
export const Button = styled.button`
  background-color: #005789;
  color: #fff;
  font-family: 'Montserrat',sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 36px;
  padding: 0 24px;
  border-radius: 4px;
  transition: background-color .4s ease-in-out;
  cursor: pointer;
  display: inline-block;
  box-sizing: border-box;
  margin-right: 10px;
  border: none;
  outline: none;
  width: 100%;
  margin-bottom: 10px;

  &:hover {
    background-color: #005789;
    color: #fff;
  }
  &.inline {
    @media (min-width: 576px) {
      width: auto;
    }
  }
  &.no-margin {
    margin-right: 0;
  }
  &.smaller {
    line-height: 32px;
  }
  &:disabled {
    opacity: .5;
    cursor: not-allowed;

    &:hover {
      background-color: #005789;
      color: #fff;
    }
  }
  &.btn-gold {
    background-color: #f6bd49;
    font-weight: bold;
    color: #000;
    font-size: 14px;
    padding: 10px 24px;

    &:hover {
      background-color: #005789;
      color: #fff;
    }
    &:disabled:hover {
      background-color: #f6bd49;
      color: #000;
    }
  }
  &.book {
    font-size: 16px;
    font-family: 'Lora', serif;
    padding: 0px 24px 4px 24px;
    width: auto;
  }
  &.outline {
    justify-self: flex-end;
    background: none;
    color: #005789;
    border: 2px solid #005789;
    font-size: 16px;
  }
  &.edit {
    max-width: 90px;
  }
`;
export const Intro = styled.div`
  margin: 30px 20px 1em 20px;
  text-align: left;
  max-height: 0;
  overflow: hidden;
  transition: all .5s ease-in-out 1s;
  @media (min-width: 768px) {
    width: 80%;
    max-width: 800px;
    margin: 30px auto 1em auto;
  }
  &.loaded {
    max-height: 1000px;
    text-align: center;
  }
`;
export const Intro2 = styled.div`
  margin: 30px 30px 0 30px;
  font-family: "Montserrat",sans-serif;
  font-size:14px;

  h2 {
    margin: 0 auto 15px auto !important;
  }
  @media (min-width: 768px) {
    width: 80%;
    margin: 30px 10% 0 10%;

    p {
      margin-bottom: 0;
    }
  }
`;
export const MessageText = styled.p`
  margin-bottom: ${props => props.withButton ? '0' : '0.5em'};
  line-height: 1.4em;
  font-weight:normal;
  font-size:14px;
  font-family: "Montserrat",sans-serif;
  text-align: left;
`;
export const Desc = styled.p`
  margin-bottom: 0.5em;
  line-height: 1.4em;
  font-weight:normal;
  font-size:14px;
  font-family: "Montserrat",sans-serif;
  text-align: center;

  @media (min-width: 520px) {
    margin-right: 20px;
  }
  @media (min-width: 768px) {
    font-size:16px;
  }
  &.left {
    text-align: left;
  }
`;
export const SmallDesc = styled.p`
  margin-bottom: 0;
  line-height: 1.1em;
  font-weight:normal;
  font-size:13px;
  font-family: "Montserrat",sans-serif;
  text-align: center;
  color: #535353;
  &.dark {
    color: #fff;
  }
  &.bold {
    font-weight: bold;
  }
  &.gray {
    color: #999;
  }
  &.left {
    text-align: left;
  }
  &.link {
    color: #005789;
    cursor: pointer;

    &:hover {
      color: #002a4e;
    }
  }
  .fa {
    font-size: 13px;
  }
`;
export const MobileDesc = styled.p`
  margin-bottom: 20px;
  padding-bottom: 20px;
  line-height: 1.2em;
  font-weight:normal;
  font-size:16px;
  font-family: "Montserrat",sans-serif;
  text-align: left;
  border-bottom: 1px solid #bbb;

  @media (min-width: 600px) {
    display: none;
  }
`;
export const SelectWrap = styled.div`
  display: inline-block;
  line-height: 1.3;
	width: 100%;
	max-width: 100%;
	margin: 0;

  &:after {
    content: '\25BC';
    color: #005789;
  }
  select {
    padding: .6em 1.4em .5em .8em;
    border: none;
    background-color: transparent;
    box-sizing: border-box;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    &::-ms-expand {
      display: none;
    }
    &:focus {
      outline: none;
    }
  }
`;
export const Subtotal = styled.div`
  position: relative;
  font-weight: normal;
  font-family: "Montserrat",sans-serif;
  font-size: 16px;
  text-align: right;

  i {
    text-decoration: line-through;
    color: #999;
    position: absolute;
    transform: translateX(-110%);
    margin-top: 2px;
    font-size: .8em;
  }
`;
export const RemoveItem = styled.div`
  font-size: 10px;
  cursor: pointer;
  position: absolute;
  bottom: -10px;
  right: 0;
  color: #005789;
  font-family: "Montserrat",sans-serif;

  &.cart {
    color: #fff;
  }
  &.dark {
    color: #ddd;
    bottom: -15px;
  }
`;
export const CounterBtn = styled.button`
  line-height: 0;
  height: 20px;
  width: 20px;
  background: none;
  border: none;
  font-size: 18px;
  font-weight: 400;
  outline: none;
  cursor: pointer;
  color: #005789;
  border: 2px solid #005789;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 5px;
  padding: 0;

  &:hover {
    background: #005789;
    color: #fff;
  }
  &.disabled {
    color: #999;
    border: 2px solid #999;
    cursor: not-allowed;

    &:hover {
      color: #999;
      background: none;
    }
  }
`;

export const Number = styled.span`
  display: inline-block;
  width: 32px;
  font-size: 20px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  background: #005789;
  font-family: "Montserrat",sans-serif;
  border-radius: 4px;
  color: #fff;
  font-weight: 600;
  &.dark {
    background: #fff;
    color: #005789;
  }
`;

export const Action = styled.div`
  padding: 20px 0 0 0;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  @media (min-width: 992px) {
    flex-wrap: nowrap;
    white-space: nowrap;
  }
  &.nowrap {
    flex-wrap: nowrap;
  }
  &.right {
    justify-content: flex-end;
  }
  &.center {
    justify-content: center;
  }
  &.nopad {
    padding: 0;
  }
  button {
    line-height: 1em;
    padding: 8px 14px;

    @media (min-width: 992px) {
      margin-right: 10px;
      padding: 8px 24px;
    }
  }
  button.checkout {
    background-color: #f6bd49;
    color: #000;
    letter-spacing: 0;
    line-height: 24px;
    font-size: 16px;
    padding: 8px 12px;
    width: 100%;
    border-radius: 4px;
    display: block;
    margin: 0;
    text-transform: none;
    border: none;
    font-family: 'Lora', serif;

    &:hover {
      background-color: #005789;
      color: #fff;
    }
    &:disabled:hover {
      background-color: #f6bd49;
      color: #000;
    }
  }
  button.disabled {
    opacity: .5;
    cursor: not-allowed;

    &:hover {
      background-color: #f6bd49;
      color: #000;
    }
  }
`;
export const CartButton = styled.div`
  cursor: pointer;
  position: relative;
  margin: 7px 0 0 10px;

  .fa-shopping-cart {
    color: #f6bd49;
    font-size: 1.5em;

    &.empty {
      color: #fff;
      font-size: 1em;
    }
  }
  .numItems {
    font-family: "Montserrat",sans-serif;
    color: #083861;
    font-size: 12px;
    font-weight: bold;
    border-radius: 40px;
    position: absolute;
    width: 100%;
    text-align: center;
    margin: 0;
    line-height: 1.5em;
  }
  &.empty path, &.empty rect {
    fill: #fff;
  }
`;
export const CartDrawer = styled.div`
  top: 0;
  min-height: 100px;
  right: 0;
  transform: translateX(100%);
  position: absolute;
  margin: 0;
  top: 0;
  width: 350px;
  padding: 20px;
  z-index: 80;
  transition: all 0.4s ease-out;

  &.visible {
    background-color: #083861;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5), inset 0 1px 3px 0 rgba(0,0,0,0.5);
    padding: 15px 20px 20px;
    transform: translateX(0);
  }
  .close {
    align-items: center;
    cursor: pointer;
    display: flex;
    justify-content: flex-end;
    font-family: "Montserrat",sans-serif;
    font-size: 10px;
    text-transform: uppercase;
    top: 15px;
    right: 25px;
    z-index: 10;

    .fa-times {
      font-size: 30px;
      margin-left: 5px;
    }
  }
  h4 {
    font-family: "Montserrat",sans-serif;
    font-weight: 700;
    line-height: 30px;
    padding-bottom: 10px;
    border-bottom: 1px solid #fff;
    font-size: 21px;
    text-transform: none;
    margin: 0;
  }
  button {
    color: #000;
    background: #f6bd49;

    &.dark {
      background: #fff;
      color: #005789;
    }
  }
`;

export const DateTimeDisplay = styled.div`
  display: flex;

  .cell {
    background: #8bd0e4;
    color: #000;
    margin: 1px;
  }
  .date {
    width: 60%;
    display: flex;
    flex-direction: column;
  }
  .time {
    width: 40%;
    display: flex;
  }
`;

export const Banner = styled.div`
  padding: 13px;
  background: #f6bd49;
  width: 100%;
  height: 50px;
  left: 0;
  z-index: 100;
  color: #000;
  font-family: "Montserrat",sans-serif;
  font-size: 14px;
  line-height: 1;
  letter-spacing: .92px;
  text-align: center;
  display: flex;
  justify-content: center;
  cursor: pointer;
  flex-direction: column;
`;
